import WatchReadings from '@/components/watch/readings/shared/Readings'
import WatchReadingsDetails from '@/components/watch/readings/shared/ReadingsDetails'
import WatchReadingsSubMenu from '@/components/watch/readings/shared/ReadingsSubMenu'

import WatchReadingsAlertHistory from '@/components/watch/readings/shared/alertsV2/ReadingsAlertHistory'
import WatchReadingsAlertView from '@/components/watch/readings/shared/alertsV2/ReadingsAlertView'
import WatchReadingsAlertViewResume from '@/components/watch/readings/shared/alertsV2/ReadingsAlertViewResume'
import WatchReadingsAlertViewHistory from '@/components/watch/readings/shared/alertsV2/ReadingsAlertViewHistory'
import WatchReadingsAlertViewResponse from '@/components/watch/readings/shared/alertsV2/ReadingsAlertViewResponse'

//import WatchBiometricAlerts from './alerts'
import Readings from '@/utils/readings'

export default [
	// biometric
	{
		path: 'biometric',
		name: 'WatchBiometric',
		redirect: 'biometric/hearth-rate',
		component: WatchReadings,
		children: [
			{
				path: ':type',
				name: 'WatchBiometricView',
				components: {
					menu: WatchReadingsSubMenu,
					default: WatchReadingsDetails
				},
				props: {
					default: (route) => ({
						user_uid: route.params.user_uid,
						watch_id: route.params.watch_id,
						type_id: Readings.readingTypesRoutes.get(route.params.type)
					}),
					menu: (route) => ({
						user_uid: route.params.user_uid,
						watch_id: route.params.watch_id,
						selected: Readings.selectedMap.get(route.params.type)
					})
				},
				children: [
					{
						path: 'alert-history',
						name: 'WatchBiometricAlertHistoryV2',
						components: { default: WatchReadingsAlertHistory },
						props: {
							default: (route) => ({
								user_uid: route.params.user_uid,
								watch_id: route.params.watch_id,
								type_id: Readings.readingTypesRoutes.get(route.params.type)
							})
						}
					},
					{
						path: 'alert-history/:alert_id',
						name: 'WatchBiometricAlertViewV2',
						redirect: 'alert-history/:alert_id/resume',
						components: { default: WatchReadingsAlertView },
						props: {
							default: (route) => ({
								user_uid: route.params.user_uid,
								watch_id: route.params.watch_id,
								type_id: Readings.readingTypesRoutes.get(route.params.type),
								alert_id: route.params.alert_id
							})
						},
						children: [
							{
								path: 'resume',
								name: 'WatchBiometricAlertViewResumeV2',
								components: { default: WatchReadingsAlertViewResume },
								props: {
									default: (route) => ({
										user_uid: route.params.user_uid,
										watch_id: route.params.watch_id,
										type_id: Readings.readingTypesRoutes.get(route.params.type),
										alert_id: route.params.alert_id
									})
								}
							},
							{
								path: 'history',
								name: 'WatchBiometricAlertViewHistoryV2',
								components: { default: WatchReadingsAlertViewHistory },
								props: {
									default: (route) => ({
										user_uid: route.params.user_uid,
										watch_id: route.params.watch_id,
										type_id: Readings.readingTypesRoutes.get(route.params.type),
										alert_id: route.params.alert_id
									})
								}
							},
							{
								path: 'response',
								name: 'WatchBiometricAlertViewResponseV2',
								components: { default: WatchReadingsAlertViewResponse },
								props: {
									default: (route) => ({
										user_uid: route.params.user_uid,
										watch_id: route.params.watch_id,
										type_id: Readings.readingTypesRoutes.get(route.params.type),
										alert_id: route.params.alert_id
									})
								}
							}
						]
					}
				]
			}
		]
	},
	// geofencing
	{
		path: 'geofencing',
		component: WatchReadings,
		children: [
			{
				path: '',
				name: 'WatchGeofencing',
				components: {
					default: WatchReadingsDetails
				},
				props: {
					default: (route) => ({
						user_uid: route.params.user_uid,
						watch_id: route.params.watch_id,
						type_id: Readings.readingTypesRoutes.get('geofencing')
					})
				},
				children: [
					{
						path: 'alert-history',
						name: 'WatchGeofencingAlertHistoryV2',
						components: { default: WatchReadingsAlertHistory },
						props: {
							default: (route) => ({
								user_uid: route.params.user_uid,
								watch_id: route.params.watch_id,
								type_id: Readings.readingTypesRoutes.get('geofencing')
							})
						}
					},
					{
						path: 'alert-history/:alert_id',
						name: 'WatchGeofencingAlertViewV2',
						redirect: 'alert-history/:alert_id/resume',
						components: { default: WatchReadingsAlertView },
						props: {
							default: (route) => ({
								user_uid: route.params.user_uid,
								watch_id: route.params.watch_id,
								type_id: Readings.readingTypesRoutes.get('geofencing'),
								alert_id: route.params.alert_id
							})
						},
						children: [
							{
								path: 'resume',
								name: 'WatchGeofencingAlertViewResumeV2',
								components: { default: WatchReadingsAlertViewResume },
								props: {
									default: (route) => ({
										user_uid: route.params.user_uid,
										watch_id: route.params.watch_id,
										type_id: Readings.readingTypesRoutes.get('geofencing'),
										alert_id: route.params.alert_id
									})
								}
							},
							{
								path: 'history',
								name: 'WatchGeofencingAlertViewHistoryV2',
								components: { default: WatchReadingsAlertViewHistory },
								props: {
									default: (route) => ({
										user_uid: route.params.user_uid,
										watch_id: route.params.watch_id,
										type_id: Readings.readingTypesRoutes.get('geofencing'),
										alert_id: route.params.alert_id
									})
								}
							},
							{
								path: 'response',
								name: 'WatchGeofencingAlertViewResponseV2',
								components: { default: WatchReadingsAlertViewResponse },
								props: {
									default: (route) => ({
										user_uid: route.params.user_uid,
										watch_id: route.params.watch_id,
										type_id: Readings.readingTypesRoutes.get('geofencing'),
										alert_id: route.params.alert_id
									})
								}
							}
						]
					}
				]
			}
		]
	}
]



// WEBPACK FOOTER //
// ./src/router/modules/watch/readingsV2.js